import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmAction from "../../components/Common/ConfirmAction";
import { deleteAgent, updateAgent } from "../../store/siteWebSlice";
import { SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../../util/functions";
import PostEditDialog from "../components/PostEditDialog";
import Edit from "./Edit";
import { IEditionPayload } from "./interface";


export default function MenuApp(props: any) {
  //props
  const { item } = props;

  //redux
  const dispatch = useDispatch();

  //hooks
  //menu
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  //edition
  const [editLoading, setEditUserLoading] = useState<boolean>(false);
  const [openEdition, setOpenEdition] = useState<boolean>(false);
  const [edition, setEdition] = useState<any>({})
  const [selectedPhoto, setSelectedPhoto] = useState<any>("")

  //suppression
  const [openSuppression, setOpenSuppression] = useState<boolean>(false)
  const [suppressionLoading, setSuppressionLoading] = useState<boolean>(false);

  //Ouvrir le menu
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu
  const handleClose = () => {
    setAnchorEl(null);
  };


  ///////////////////////////////////////// edition  ///////////////////////////////////////////////////
  //Ouvrir la boite de dialog puis mise à jour de l'objet edition
  const handleEditionDialogOpen = (item: any) => {
    setOpenEdition(true);
    setEdition(item)
  };

  //Fermer la boite de dialog d'edition 
  const handleEditionDialogClose = () => {
    setOpenEdition(false);
  };


  //Enregistrer les modifications apportées 
  const handleEditSave = async (e: any) => {
    e.preventDefault();
    try {
      setEditUserLoading(true);
      // Obtenir l'image en base64
      const agentImageEnBase64: string | undefined | unknown = selectedPhoto ? await convertToBase64(selectedPhoto) : "";
      //constituer le payload
      const apiPayload: IEditionPayload = {
        idAgent: edition.idAgent,
        nomAgent: edition.nomAgent,
        idFonction: edition.idFonction,
        idService: edition.idService,
        photoAgent: edition.photoAgent,
        agentImageEnBase64: agentImageEnBase64
      }
      //Envoie de la requete
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/modifieragent",
        apiPayload
      );
      if (res.status === 1) {
        dispatch(updateAgent(res.data));
        setEditUserLoading(false);
        // handleActiveDesactiveDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setEditUserLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:108 ~ handleSave ~ error:", error)
      setEditUserLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };


  /////////////////////////////////////////////////  suppression  /////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog suppression
  const handleSuppressionDialogOpen = () => {
    setOpenSuppression(true);
  };

  //Fermer la boite de dialog suppression
  const handleSuppressionDialogClose = () => {
    setOpenSuppression(false);
  };

  //Supprimer un agent dans la bd
  const handleDelete = async (e: any) => {
    e.preventDefault();
    try {
      setSuppressionLoading(true);

      //constituer le payload
      const apiPayload = {
        idAgent: item.idAgent
      };

      //Envoi de la requete vers api
      const res: any = await apiClient.post(
        SITEWEB_SERVER_BASE_URL,
        "/supprimeragent",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(deleteAgent(res.data));
        setSuppressionLoading(false);
        handleSuppressionDialogClose();
        successNotify("Action éffectuée avec succès");
      } else {
        setSuppressionLoading(false);
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:225 ~ handleDelete ~ error:", error)
      setSuppressionLoading(false);
      errorNotify("Une erreur s'est produite.");
    }
  };




  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >

        <MenuItem
          onClick={() => {
            handleEditionDialogOpen(item);
          }}
        >
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Modifier
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleSuppressionDialogOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>
      </Menu>


      {/* edition */}
      <PostEditDialog
        onClose={handleEditionDialogClose}
        open={openEdition}
        dialogContent={
          <Edit
            edition={edition}
            setEdition={setEdition}
            setSelectedPhoto={setSelectedPhoto}
          />}
        actionFunc={handleEditSave}
        title="Edition"
        editLoading={editLoading}
      />

      {/* Suppression */}
      <ConfirmAction
        title={`Suppression`}
        dialogContent={`Voulez vous réellement supprimer cet agent ?`}
        actionLabel="Oui"
        open={openSuppression}
        handleClose={handleSuppressionDialogClose}
        actionFunction={handleDelete}
        addLoading={suppressionLoading}
        iconeSauveButton={<DeleteIcon />}
      />

    </React.Fragment>
  );
}
